module.exports = ".highlight {\n  font-weight: 700; }\n\n.alert-panel {\n  margin-left: 0 !important;\n  margin-right: 0 !important; }\n"